import Markdown from 'markdown-to-jsx';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLanguagePreference } from '../../hooks/useLanguagePreference';
import { PageLayout } from '../../layout/PageLayout';
import './HelpPages.scss';

const Help = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    context: { userLanguagePreference },
  } = useLanguagePreference();
  const [helpDocument, setHelpDocument] = React.useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (userLanguagePreference !== null) {
      import(`./help-markdown/help_${userLanguagePreference}.md`)
        .then((res) => {
          fetch(res.default)
            .then((res) => res.text())
            .then((res) => setHelpDocument(res))
            .catch(() => navigate('/page-not-found'));
        })
        .catch(() => navigate('/page-not-found'));
    }
  }, [userLanguagePreference, navigate]);

  return (
    <PageLayout headerTitle={t('help-pages.help-title')}>
      <div className="help-pages">
        <Markdown>{helpDocument}</Markdown>
      </div>
    </PageLayout>
  );
};

export default Help;
